export default "__VITE_ASSET__arw40D9r__"